/**
 * Deep merge utility that preserves nested values across wizard steps.
 * Arrays are replaced; objects are merged recursively.
 */
const deepMerge = (target, source) => {
  if (source == null || typeof source !== 'object') return source;
  if (Array.isArray(source)) return source;
  
  const out = Array.isArray(target) ? [] : { ...(target || {}) };
  
  for (const [k, v] of Object.entries(source)) {
    if (v != null && typeof v === 'object' && !Array.isArray(v)) {
      out[k] = deepMerge(out[k], v);
    } else {
      out[k] = v;
    }
  }
  
  return out;
};

export default deepMerge;
